import React from 'react';
import { Flex, Typography, theme } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { CustomTooltip } from '~components/Tooltip';
import { useIsPrinting } from '~library/print';

import useAiInsightsChartDescriptionsState from './useAiInsightsChartDescriptionsState';

type AiInsightsSectionHeadingProps = {
  title: string;
  description: string;
};

// The section title with its explanatory line. Turning chart descriptions off
// does not discard the sentence: it moves to an info icon beside the title, the
// same paragraph/tooltip swap ChartCard makes on the main dashboard. One copy of
// the text either way.
function AiInsightsSectionHeading({ title, description }: AiInsightsSectionHeadingProps) {
  const { token } = theme.useToken();
  const [descriptionsEnabled] = useAiInsightsChartDescriptionsState();
  const { isPrinting } = useIsPrinting();

  // An exported PDF always states the description outright: an info icon on
  // paper is a dead end, so a screen preference for hiding it cannot be allowed
  // to strip the sentence from the export.
  const descriptionVisible = descriptionsEnabled || isPrinting;

  return (
    <Flex vertical gap={token.marginXXS}>
      <Flex align="center" gap={token.marginXXS}>
        <Typography.Title level={4} style={{ margin: 0, fontSize: token.fontSizeHeading4 }}>
          {title}
        </Typography.Title>
        {!descriptionVisible && (
          <CustomTooltip placement="top" message={description}>
            <InfoCircleOutlined style={{ color: token.colorIcon }} />
          </CustomTooltip>
        )}
      </Flex>

      {descriptionVisible && (
        <Typography.Text type="secondary" style={{ fontSize: token.fontSize }}>
          {description}
        </Typography.Text>
      )}
    </Flex>
  );
}

export default AiInsightsSectionHeading;
